// 代理ログインバーの事業者切替メニューの絞り込み (manage / shops の両 pack から読む)
function setupSwitcherFilter() {
  const switcher = document.getElementById('proxy_login_list');
  if (!switcher) return;

  const filter = switcher.querySelector('[data-switcher-filter]');
  const empty = switcher.querySelector('[data-switcher-empty]');
  const items = Array.from(switcher.querySelectorAll('[data-switcher-item]'));
  if (!filter || !empty || items.length === 0) return;

  // 絞り込みは JS でしか効かないので、ここまで来てから出す
  filter.hidden = false;

  filter.addEventListener('input', () => {
    const keyword = filter.value.trim().toLowerCase();
    const matched = items.filter((item) => {
      const hit = item.dataset.switcherItem.toLowerCase().includes(keyword);
      item.hidden = !hit;
      return hit;
    });
    empty.hidden = matched.length > 0;
  });

  switcher.addEventListener('toggle', () => {
    // 狭い画面でフォーカスするとソフトキーボードが一覧を覆うので、広い画面だけにする
    // (768px = _agent_proxy_login.scss で位置を切り替えるのと同じ境界)
    if (switcher.open && window.matchMedia('(min-width: 768px)').matches) {
      filter.focus();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupSwitcherFilter);
} else {
  setupSwitcherFilter();
}
